import { Text as Paragraph } from '@/components/Typography';

export const DescElement = ({
  text,
  dataTest,
}: {
  text: string;
  tag?: string;
  dataTest?: string;
}) => {
  return (
    <Paragraph tag="p" type="lg" data-test={dataTest} className="banner-2-description">
      {text}
    </Paragraph>
  );
};
